import React, { useState, useRef, useEffect } from "react";
import { getXlsSearchParams, getPdfCalendarioUnicoSearchParams } from "../Castelletto/utility/config-file";
import { InputElement, CheckBox, ConfirmModal, Pagination } from "../../components";
import { utilityFunction } from "../../fanctionUtility";
import { dayJS } from "../../applicationConf";
import { useSelector } from "react-redux";
import new_axios_instance from "../../axios_instance";
import { CSSTransition } from "react-transition-group";
import { loadStorage } from "../../sessionStorage";
import {
    convertBase64ToBlob,
    encodeUnicode,
} from "../../fanctionUtility";
import { getUltimaPianificazione } from "../../actions/actions/pianificazioneActions";


const Esporta = () => {

    const [searchParams, setSearchParams] = React.useState(getXlsSearchParams());

    const [isFormValid, setIsFormValid] = React.useState(false);
    const [isPending, setIsPending] = React.useState(false);

    const corso = useSelector(state => state.corso.corso);
    const ruoloScelto = useSelector(state => state.auth.ruoloScelto);
    const [formElements, setFormElements] = useState([]);

    const [selectedValue, setSelectedValue] = useState('');
    const [showContent, setShowContent] = useState(false);

    const [allPeriodchecked, setAllPeriodChecked] = React.useState(false);

    const [ultimaPianificazione, setUltimaPianificazione] = React.useState({})

    const [disableButton, setDisableButton] = React.useState(false)

    // Stati per il modal di conferma esportazione
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [exportParams, setExportParams] = useState(null);

    // Stati per lo storico esportazioni
    const [storicoEsportazioni, setStoricoEsportazioni] = useState([]);
    const [storicoLoading, setStoricoLoading] = useState(false);
    const [storicoCurrentPage, setStoricoCurrentPage] = useState(1);
    const [storicoTotalPages, setStoricoTotalPages] = useState(1);
    const [storicoTotalCount, setStoricoTotalCount] = useState(0);
    const [storicoPageSize] = useState(10);

    useEffect(() => {
        const fetchUltimaPianificazione = async () => {
            if (corso && corso.dataFine == null) {
                const result = await getUltimaPianificazione(corso.id);
                setUltimaPianificazione(result);
            }
        };

        fetchUltimaPianificazione();
    }, [corso]);

    const changeAllPeriod = () => {
        setAllPeriodChecked(prevState => {
            const newState = !prevState;
            const _searchParams = { ...searchParams };

            if (newState) {
                const options = utilityFunction(corso.dataInizio, (corso.dataFine ?? ultimaPianificazione?.data ?? new Date())).map(completeDate => ({
                    value: dayJS(completeDate, 'YYYY-M-D').format('YYYY-MM'),
                    displayValue: dayJS(completeDate, 'YYYY-M-D').format('YYYY - MMMM')
                }));

                if (options.length >= 1) {
                    const firstValue = options[0].value;
                    _searchParams.daData.value = firstValue;
                }

                const lastValue = options[options.length - 1].value;
                _searchParams.aData.value = lastValue;

                _searchParams.daData.elementConfig.disabled = true;
                _searchParams.aData.elementConfig.disabled = true;
            } else {
                _searchParams.daData.elementConfig.disabled = false;
                _searchParams.aData.elementConfig.disabled = false;
            }


            if (dayJS(_searchParams.daData.value).isAfter(dayJS(_searchParams.aData.value))) {
                setDisableButton(true)
                return
            }
    
            setDisableButton(false)

            return newState;
        });
    };

    const handleSelectChange = (event) => {
        const value = event.target.value;
        setSelectedValue(value);

        if (value === 'riepilogo') {
            setSearchParams(getXlsSearchParams());
        } else if (value === 'calendario') {
            setSearchParams(getPdfCalendarioUnicoSearchParams());
        }

        setShowContent(true);
    };

    const docenti = useSelector(state => state.docenti.docenti);

    const prevSearchParamsRef = useRef();

    React.useEffect(() => {

        const _searchParams = { ...searchParams };
        const options = utilityFunction(corso.dataInizio, corso.dataFine ?? ultimaPianificazione?.data ?? new Date()).map(completeDate => ({
            value: dayJS(completeDate, 'YYYY-M-D').format('YYYY-MM'),
            displayValue: dayJS(completeDate, 'YYYY-M-D').format('YYYY - MMMM')
        }));

        _searchParams.daData.elementConfig.options = options;
        _searchParams.daData.valid = searchParams.daData.elementConfig.options.length > 0;
        _searchParams.aData.elementConfig.options = options;
        _searchParams.aData.valid = searchParams.daData.elementConfig.options.length > 0;

        _searchParams.individuo.valid = true;

        if (_searchParams.individuo.label === 'Unità Formativa') {
            const unitaFormative = docenti.map(dc => dc.unitaFormative).flat();
            _searchParams.individuo.elementConfig.options = unitaFormative.map(uf => ({
                value: uf.codice,
                displayValue: uf.descrizione
            }));
        }

        if (JSON.stringify(prevSearchParamsRef.current) !== JSON.stringify(_searchParams)) {
            if (dayJS(corso.dataInizio).isBefore(dayJS(new Date())) && dayJS(corso.dataFine ?? ultimaPianificazione?.data).isAfter(new Date())) {
                _searchParams.daData.value = dayJS(new Date()).format('YYYY-MM')
                _searchParams.aData.value = dayJS(new Date()).format('YYYY-MM')
            } else {
                _searchParams.daData.value = options[options.length - 1].value;
                _searchParams.aData.value = options[options.length - 1].value;
            }
 
            setSearchParams(_searchParams);
            setFormElements(Object.keys(_searchParams).map(key => ({ id: key, config: _searchParams[key] })));
            prevSearchParamsRef.current = _searchParams;
        }

        if (dayJS(_searchParams.daData.value).isAfter(dayJS(_searchParams.aData.value))) {
            setDisableButton(true)
            return
        }

        setDisableButton(false)
    }, [corso, searchParams, docenti, ultimaPianificazione?.dataFine]);

    const checkFormValidity = React.useCallback((form) => {
        return Object.keys(form)
            .filter(key => form[key].validation.required)
            .map(key => form[key].valid)
            .reduce((validity, valid) => validity && valid, true);
    }, []);

    React.useEffect(() => {
        setIsFormValid(checkFormValidity(searchParams));
    }, [searchParams, checkFormValidity])

    const handlerChange = React.useCallback((target, formElement) => {
        const _searchParams = { ...searchParams };
        _searchParams[formElement.id].value = target.value;
        setFormElements(Object.keys(_searchParams).map(key => ({ id: key, config: _searchParams[key] })));
        setSearchParams(_searchParams);

    }, [searchParams]);

    // Funzioni per gestire lo storico esportazioni
    const caricaStoricoEsportazioni = React.useCallback(async () => {
        if (!corso || !corso.id) return;

        setStoricoLoading(true);
        try {
            const response = await new_axios_instance.get('/v1/esportazione/storico', {
                params: {
                    idCorso: corso.id,
                    page: storicoCurrentPage - 1,
                    size: storicoPageSize,
                    tipoEsportazione: 'CALENDARIO_UNICO_PDF'
                }
            });

            setStoricoEsportazioni(response.data.responses || []);
            const totalCount = response.data.totalCount || 0;
            const totalPages = Math.ceil(totalCount / storicoPageSize);
            setStoricoTotalCount(totalCount);
            setStoricoTotalPages(totalPages || 1);
        } catch (error) {
            console.error('Errore nel caricamento dello storico esportazioni:', error);
            setStoricoEsportazioni([]);
        } finally {
            setStoricoLoading(false);
        }
    }, [corso, storicoCurrentPage, storicoPageSize]);

    const scaricaEsportazioneStoricizzata = React.useCallback(async (idEsportazione) => {
        try {
            const response = await new_axios_instance.get(`/v1/esportazione/scarica/${idEsportazione}`, {
                responseType: 'arraybuffer'
            });

            const blob = new Blob([response.data], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);

            const a = document.createElement('a');
            a.href = url;
            a.download = `calendario_storicizzato_${idEsportazione}.pdf`;
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Errore nel download dell\'esportazione storicizzata:', error);
        }
    }, []);

    const cambiaPaginaStorico = React.useCallback((page) => {
        setStoricoCurrentPage(page);
    }, []);

    const esportaReport = React.useCallback(async (individuo, daData, aData) => {
        setIsPending(true);
        try {
            const response = await new_axios_instance.get(`/v1/corso/esporta/${corso.id}/daMese/${daData}/aMese/${aData}`,
                {
                    responseType: 'arraybuffer',
                    params: {
                        individuo
                    }
                });
            const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const url = window.URL.createObjectURL(blob);

            const a = document.createElement('a');
            a.href = url;

            a.download = "file.xls"
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Error downloading file:', error);
        } finally {
            setIsPending(false);
        }
    }, [corso]);

    const downloadPdf = React.useCallback(() => {
        const unitaFormativaDescrizione = searchParams.individuo.value 
            ? searchParams.individuo.elementConfig.options.find(opt => opt.value === searchParams.individuo.value)?.displayValue
            : null;
        
        // Se è allievo, esporta direttamente senza storicizzare
        if (ruoloScelto === 'allievo') {
            esportaPdf(searchParams.individuo.value, unitaFormativaDescrizione, searchParams.daData.value, searchParams.aData.value, false);
            return;
        }
        
        setExportParams({
            unitaFormativa: searchParams.individuo.value,
            unitaFormativaDescrizione: unitaFormativaDescrizione,
            daData: searchParams.daData.value,
            aData: searchParams.aData.value
        });
        setShowConfirmModal(true);
    }, [searchParams, ruoloScelto]);

    const handleConfirmExportWithoutStorage = async () => {
        setShowConfirmModal(false);
        await esportaPdf(exportParams.unitaFormativa, exportParams.unitaFormativaDescrizione, exportParams.daData, exportParams.aData, false);
        setExportParams(null);
    };

    const handleConfirmExportWithStorage = async () => {
        setShowConfirmModal(false);
        await esportaPdf(exportParams.unitaFormativa, exportParams.unitaFormativaDescrizione, exportParams.daData, exportParams.aData, true);
        setExportParams(null);
    };

    const handleCancelExport = () => {
        setShowConfirmModal(false);
        setExportParams(null);
    };

    const esportaPdf = async (unitaFormativa, unitaFormativaDescrizione, daData, aData, storicizza = false) => {
        setIsPending(true);
        try {
            const requestData = {
                idCorso: corso.id,
                unitaFormativa: unitaFormativa || null,
                unitaFormativaDescrizione: unitaFormativaDescrizione || null,
                daData: daData,
                aData: aData,
                storicizza: storicizza
            };

            const response = await new_axios_instance.post(
                '/v1/esportazione/calendario/pdf',
                requestData,
                { responseType: 'arraybuffer' }
            );

            // Il backend restituisce direttamente il PDF
            const blob = new Blob([response.data], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = 'calendario.pdf';
            document.body.appendChild(a);
            a.click();
            window.URL.revokeObjectURL(url);
            document.body.removeChild(a);

            if (storicizza) {
                console.log('Esportazione storicizzata con successo');
                // Ricarica lo storico
                caricaStoricoEsportazioni();
            }

        } catch (error) {
            console.log(error);
        } finally {
            setIsPending(false);
        }
    };


    const clearModifiedPlanningComplessivo = (planningComplessivo) => {

        const getKey = (event) =>
            `${event.data}-${event.oraInizio}-${event.oraFine}-${event.docente}-${event.descrizioneUnitaFormativa}`;

        const uniqueEvents = new Map();

        planningComplessivo.forEach(event => {
            const key = getKey(event);

            if (uniqueEvents.has(key)) {

                const existingEvent = uniqueEvents.get(key);

                if (new Date(event.versione) > new Date(existingEvent.versione)) {

                    uniqueEvents.set(key, event);
                }
            } else {
                uniqueEvents.set(key, event);
            }
        });
        return Array.from(uniqueEvents.values());
    };

    const downloadExcel = React.useCallback(() => {
        esportaReport(searchParams.individuo.value, searchParams.daData.value, searchParams.aData.value);
    }, [searchParams.individuo.value, searchParams.daData.value, searchParams.aData.value, esportaReport]);

    // Carica lo storico esportazioni quando cambia il corso
    useEffect(() => {
        if (corso && corso.id) {
            caricaStoricoEsportazioni();
        }
    }, [corso, storicoCurrentPage, caricaStoricoEsportazioni]);

    return (
        <div className='card shadowCustom animate__animated animate__fadeIn'>
            <div className='card-header'>
                <h4>Esporta</h4>
            </div>
            <div className='card-body'>

                <h5 style={{ paddingBottom: '5px' }}>Seleziona il tipo di file da esportare</h5>

                <div className="mb-3">
                    <select value={selectedValue} onChange={handleSelectChange} className="form-control" style={{ width: 'auto', minWidth: '220px', maxWidth: '100%' }}>
                        <option value="" disabled>Seleziona...</option>
                        {ruoloScelto !== 'allievo' && <option value="riepilogo">Riepilogo corso XLS</option>}
                        <option value="calendario">Calendario unico PDF</option>
                    </select>
                </div>

                <CSSTransition
                    in={showContent}
                    timeout={500}
                    classNames="fade"
                    unmountOnExit
                >

                    <div style={{ paddingTop: '25px' }}>
                        {selectedValue === 'riepilogo' && (
                            <div className="content-section">
                                <form className='needs-validation animate__animated animate__fadeIn'>
                                    <div className='row'>

                                        {formElements.map(formElement =>
                                            <InputElement key={formElement.id}
                                                label={formElement.config.label}
                                                elementType={formElement.config.elementType}
                                                elementConfig={formElement.config.elementConfig}
                                                value={formElement.config.value}
                                                invalid={!formElement.config.valid}
                                                touched={formElement.config.touched}
                                                changedValue={({ target }) => handlerChange(target, formElement)}
                                                isRequired={formElement.config.validation.required}
                                                classes={formElement.config.cssClass}
                                                style={formElement.config.style}
                                                feedback={formElement.config.error}
                                            />
                                        )}

                                        <section
                                            className='col d-flex flex-wrap align-items-end justify-content-start justify-content-md-end justify-content-lg-end pt-3 pt-md-0 pt-lg-0'>
                                            <button type='button'
                                                className='btn btn-primary shadow customTooltip'
                                                onClick={() => downloadExcel()}
                                                disabled={!isFormValid || isPending || disableButton}>
                                                <i className='fa fa-download' />
                                                <span className='pl-2'>{isPending ? 'Esportazione...' : 'Esporta XLS'}</span>
                                                <span className="customTooltiptext">Filtri più stringenti possono velocizzare l'esportazione</span>
                                            </button>
                                        </section>

                                    </div>
                                </form>
                            </div>
                        )}
                        {selectedValue === 'calendario' && (
                            <div className="content-section">
                                <form className='needs-validation animate__animated animate__fadeIn'>
                                    <div className='row'>

                                        {formElements.map(formElement =>
                                            <InputElement key={formElement.id}
                                                label={formElement.config.label}
                                                elementType={formElement.config.elementType}
                                                elementConfig={formElement.config.elementConfig}
                                                value={formElement.config.value}
                                                invalid={!formElement.config.valid}
                                                touched={formElement.config.touched}
                                                changedValue={({ target }) => handlerChange(target, formElement)}
                                                isRequired={formElement.config.validation.required}
                                                classes={formElement.config.cssClass}
                                                style={formElement.config.style}
                                                feedback={formElement.config.error}
                                            />
                                        )}


                                        <div id='containerAllPeriodEsporta' className={'col-12 col-sm-8 col-md-3 containerAllPeriodEsporta'} >
                                            <CheckBox check={allPeriodchecked} customCss={{ width: '20px' }} changeValue={(event) => changeAllPeriod(event)} />
                                            <label id='allPeriod' style={{ marginLeft: '15px' }}>
                                                Tutto il periodo
                                            </label>
                                        </div>

                                        <section
                                            className='col d-flex flex-wrap align-items-end justify-content-start justify-content-md-end justify-content-lg-end pt-3 pt-md-0 pt-lg-0'>
                                            <button type='button'
                                                className='btn btn-primary shadow customTooltip'
                                                onClick={() => downloadPdf()}
                                                disabled={!isFormValid || isPending || disableButton}>
                                                <i className='fa fa-download' />
                                                <span className='pl-2'>{isPending ? 'Esportazione...' : 'Esporta PDF'}</span>
                                                <span className="customTooltiptext">Filtri più stringenti possono velocizzare l'esportazione</span>
                                            </button>
                                        </section>

                                    </div>
                                </form>
                            </div>
                        )}
                    </div>

                </CSSTransition>

                {/* Sezione Storico Esportazioni - visibile solo per calendario PDF */}
                {selectedValue === 'calendario' && (
                    <div style={{ marginTop: '30px' }}>
                        <h5 style={{ paddingBottom: '15px' }}>Storico esportazioni</h5>

                        {storicoLoading ? (
                            <div className="text-center">
                                <i className="fa fa-spinner fa-spin"></i> Caricamento...
                            </div>
                        ) : (
                            <>
                                <div className="table-responsive">
                                    <table className="table table-striped table-hover">
                                        <thead className="thead-light">
                                            <tr>
                                                <th>Data esportazione</th>
                                                <th>Utente</th>
{/*                                                 <th>Codice fiscale</th> */}
                                                <th>Unità formativa</th>
                                                <th>Da</th>
                                                <th>A</th>
                                                <th>Azione</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {storicoEsportazioni.length === 0 ? (
                                                <tr>
                                                    <td colSpan="7" className="text-center">
                                                        Nessuna esportazione storicizzata trovata
                                                    </td>
                                                </tr>
                                            ) : (
                                                storicoEsportazioni.map((esportazione) => {
                                                    return (
                                                        <tr key={esportazione.id}>
                                                            <td>{dayJS(esportazione.dataEsportazione).format('DD/MM/YYYY HH:mm:ss')}</td>
                                                            <td>{esportazione.nomeUtente}</td>
{/*                                                             <td>{esportazione.codiceFiscaleUtente}</td> */}
                                                            <td>{esportazione.unitaFormativa?.descrizione || 'Tutte'}</td>
                                                            <td>{dayJS(esportazione.daData).format('MM/YYYY')}</td>
                                                            <td>{dayJS(esportazione.aData).format('MM/YYYY')}</td>
                                                            <td>
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-sm btn-primary"
                                                                    onClick={() => scaricaEsportazioneStoricizzata(esportazione.id)}
                                                                    title="Scarica PDF"
                                                                >
                                                                    <i className="fa fa-download"></i>
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    );
                                                })
                                            )}
                                        </tbody>
                                    </table>
                                </div>

                                <Pagination
                                    activePage={storicoCurrentPage}
                                    itemsCountPerPage={storicoPageSize}
                                    totalItemsCount={storicoTotalCount}
                                    recordTotali={storicoTotalCount}
                                    pagineTotali={storicoTotalPages}
                                    onChange={cambiaPaginaStorico}
                                    hideNavigation={storicoTotalCount / storicoPageSize < 1}
                                />
                            </>
                        )}
                    </div>
                )}

            </div>

            {/* Modal di conferma per esportazione definitiva */}
            <ConfirmModal
                visible={showConfirmModal}
                title="Conferma Esportazione"
                onCancel={handleCancelExport}
                onOK={null}
            >
                <p>Stai facendo un'esportazione definitiva?</p>
                <div className="d-flex justify-content-between mt-3">
                    <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={handleConfirmExportWithoutStorage}
                    >
                        No, stampa senza storicizzare
                    </button>
                    <button
                        type="button"
                        className="btn btn-primary"
                        onClick={handleConfirmExportWithStorage}
                    >
                        Sì, stampa e storicizza
                    </button>
                </div>
            </ConfirmModal>
        </div>
    )
}

export default Esporta;